import { selectCavalliKeyList, selectHeaderList } from 'features/ippica/selectors';

import { IppicaEmpty } from '../../ippicaEmpty';
import { IppicaScommesseTableRow } from '../../ippicaScommesseTableRow';
import { IppicaScommesseTableTitles } from '../../ippicaScommesseTableTitles';
import styles from '../IppicaScommesseRenderer.module.scss';
import { useHasCampiActive } from 'features/ippica/hooks';
import { useTypedSelector } from 'lib/centralStore';

export type IppicaScommesseRendererWithCavalliKeyProps = {
  tipoScommessaKey: string | undefined;
  isMobile: boolean;
};

export const IppicaScommesseRendererWithCavalliKey = ({
  tipoScommessaKey,
  isMobile,
}: IppicaScommesseRendererWithCavalliKeyProps) => {
  const hasCampiActive = useHasCampiActive(tipoScommessaKey);
  const headerListSelected = useTypedSelector(selectHeaderList(hasCampiActive ? true : false));
  const cavalliKeyList = useTypedSelector(selectCavalliKeyList);

  return (
    <>
      {!isMobile && <IppicaScommesseTableTitles titles={headerListSelected} />}
      {!!cavalliKeyList?.length ? (
        cavalliKeyList.map((keyCavallo: string, indexCavallo: number) => (
          <IppicaScommesseTableRow key={keyCavallo} indexCavallo={indexCavallo} keyCavallo={keyCavallo} />
        ))
      ) : (
        <IppicaEmpty>
          <div className={styles.wrapperEmptyState}>
            <span>Non ci sono cavalli disponibili.</span>
            <span>Riprova più tardi</span>
          </div>
        </IppicaEmpty>
      )}
    </>
  );
};
